// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"0766510e","97":"72d0afdb"}[chunkId] + ".chunk.js";
};